  import React, { useEffect, useRef } from "react";
  import { motion } from "framer-motion";
  import { gsap } from "gsap";
  import * as THREE from "three";
  import { useNavigate } from "react-router-dom";

  const ThankYou = () => {
    const threeRef = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
      gsap.fromTo(
        ".thankyou-message",
        { opacity: 0, y: 20 },
        { opacity: 1, y: 0, duration: 1.5, ease: "power3.out" }
      );

      const handleKeyDown = (event) => {
        if (event.key === "Escape") {
          navigate("/construction");
        }
      };

      window.addEventListener("keydown", handleKeyDown);

      const scene = new THREE.Scene();
      const camera = new THREE.PerspectiveCamera(
        75,
        threeRef.current.clientWidth / threeRef.current.clientHeight,
        0.1,
        1000
      );
      const renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true });
      renderer.setSize(
        threeRef.current.clientWidth,
        threeRef.current.clientHeight
      );
      threeRef.current.appendChild(renderer.domElement);

      const geometry = new THREE.BoxGeometry();
      const material = new THREE.MeshStandardMaterial({ color: 0x007bff });
      const cube = new THREE.Mesh(geometry, material);
      scene.add(cube);

      const ambientLight = new THREE.AmbientLight(0xffffff, 0.6);
      scene.add(ambientLight);
      const directionalLight = new THREE.DirectionalLight(0xffffff, 0.8);
      directionalLight.position.set(5, 5, 5);
      scene.add(directionalLight);

      camera.position.z = 3;

      const animate = function () {
        requestAnimationFrame(animate);
        cube.rotation.x += 0.01;
        cube.rotation.y += 0.01;
        renderer.render(scene, camera);
      };

      animate();

      return () => {
        window.removeEventListener("keydown", handleKeyDown);
        renderer.dispose();
        if (threeRef.current && renderer.domElement.parentNode === threeRef.current) {
          threeRef.current.removeChild(renderer.domElement);
        }
      };
    }, []);

    return (
      <div
        style={{
          height: "100vh",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "20px",
          textAlign: "center",
          position: "relative",
        backgroundImage:
          "url('https://cdn.pixabay.com/photo/2021/11/07/22/16/construction-6778044_1280.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          overflow: "hidden",
        }}
      >
        {/* Dark overlay */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 0,
          }}
        />
        {/* Close Button */}
        <button
          onClick={() => navigate("/construction")}
          style={{
            position: "absolute",
            top: "20px",
            right: "20px",
            background: "transparent",
            border: "none",
            fontSize: "2rem",
            cursor: "pointer",
            color: "#ffffff",
            fontWeight: "bold",
            lineHeight: "1",
            zIndex: 1,
          }}
          aria-label="Close"
        >
          &times;
        </button>
        {/* Content */}
        <motion.h1
          className="thankyou-message"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.5, ease: "easeOut" }}
          style={{
            fontSize: "3rem",
            marginBottom: "1rem",
            color: "#ffffff",
            zIndex: 1,
          }}
        >
          Thank You!
        </motion.h1>
        <motion.p
          className="thankyou-message"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 1.5, ease: "easeOut" }}
          style={{
            fontSize: "1.25rem",
            maxWidth: "600px",
            marginBottom: "2rem",
            color: "#f0f0f0",
            zIndex: 1,
          }}
        >
          We're thrilled you got in touch.
        </motion.p>
        <div
          ref={threeRef}
          style={{
            width: "300px",
            height: "300px",
            marginTop: "2rem",
            zIndex: 1,
          }}
        />
      </div>
    );
  };

  export default ThankYou;
